import React from 'react';
import { connect } from 'react-redux';
import ProfileActions from '../profile/Profile.actions';
import PropTypes from 'prop-types';

function withLayoutService (Component) {
  /**
   * Layout services
  */
  class LayoutService extends React.Component {
    componentDidMount () {
      this.props.dispatch(ProfileActions.LOAD_USER_AVAILABILITY);
    }

    render () {
      return <Component {...this.props} layoutService={this} />;
    }
  }

  const mapStateToProps = (state) => ({});
  const mapDispatchToProps = (dispatch) => ({ dispatch });

  LayoutService.propTypes = {
    dispatch: PropTypes.func
  };

  return connect(mapStateToProps, mapDispatchToProps)(LayoutService);
}

export default withLayoutService;
